import { createFileRoute } from "@tanstack/react-router";

import { DrillPage } from "@/features/drills";

// «Тренировка»: экран целиком из фичи `drills`.
export const Route = createFileRoute("/drills")({
  component: DrillPage,
});
